import { apiPost } from './client';

interface BillingPortalResponse {
  success: boolean;
  url: string;
}

/**
 * Create a Stripe Billing Portal session.
 * Returns the portal URL where the customer can manage their subscriptions,
 * view invoices, and update payment methods.
 */
export async function createBillingPortalSession(): Promise<string> {
  const response = await apiPost<BillingPortalResponse>(
    '/api/customer/billing/portal-session'
  );
  return response.url;
}
